const daydemandStateFliter = function(input) {
  // 0--未提报1-提报待受理2-提报待调度受理3-提报内部拒绝4-提报调度拒绝5-提报通过10-退订通过
    switch (input) {
      case '0':
        return '待提报'
      case '1':
        return '待受理'
      case '2':
        return '待受理'
      case '3':
        return '已拒绝'
      case '4':
        return '已拒绝'
      case '5':
        return '受理通过'
      case '10':
        return '已退订'
    }
}
let filterObj = {}
filterObj.daydemandState = daydemandStateFliter
export default filterObj
